import React, { useState, useRef, useEffect } from "react";
import "./login.css";
import logo1 from '../assets/CPA1.png'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import Toast from "./Toast";
import API_BASE_URL from "../apiConfig";

export default function Login({ setIsAuthenticated }) {
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [toast, setToast] = useState(null);
  const userIdRef = useRef(null);

  useEffect(() => {
    if (userIdRef.current) {
      userIdRef.current.focus();
    }
  }, []);

  const validate = () => {
    let newErrors = {};
    if (!userId) newErrors.userId = "User ID is required";
    if (!password) newErrors.password = "Password is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setIsLoading(true);
      try {
        const response = await fetch(`${API_BASE_URL}/therapist_api/therapist_login.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            moodle_id: userId,
            password: password,
          }),
        });
        
        const data = await response.json();
        
        if (data.status) {
          localStorage.setItem("token", data.token);
          localStorage.setItem("user", JSON.stringify(data.user));
          setToast({ message: "Login successful", type: "success" });
          setTimeout(() => {
            if (setIsAuthenticated) {
              setIsAuthenticated(true);
            }
            window.location.href = "/Home";
          }, 1500);
        } else {
          setToast({ message: data.message || "Invalid User credentials", type: "error" });
          setErrors({ password: data.message || "Invalid credentials" });
        }
      } catch (error) {
        console.error("Login error:", error);
        setToast({ message: "Invalid User credentials", type: "error" });
        setErrors({ password: "An error occurred during login" });
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <div className="login-container body1">
      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}
      <div className="login-box">
        <div className="logo">
          <img src={logo1} className="logo1" alt="CPA Logo" />
        </div>
        <h1 className="login-title">Login</h1>
        <form onSubmit={handleSubmit} noValidate>
          <div className="form-group">
            <label htmlFor="login-userid">User ID</label>
            <input
              ref={userIdRef}
              id="login-userid"
              type="text"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              placeholder="Enter User ID"
              className="user_inp"
              aria-required="true"
              aria-invalid={errors.userId ? "true" : "false"}
              aria-describedby={errors.userId ? "userid-error" : undefined}
            />
            {errors.userId && <span className="error" id="userid-error" role="alert">{errors.userId}</span>}
          </div>
          <div className="form-group">
            <label htmlFor="login-password">Password</label>
            <div className="password-field">
              <input
                id="login-password"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter Password"
                className="user_inp"
                aria-required="true"
                aria-invalid={errors.password ? "true" : "false"}
                aria-describedby={errors.password ? "password-error" : undefined}
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                <FontAwesomeIcon className="login-icon" icon={showPassword ? faEye : faEyeSlash} aria-hidden="true" />
              </button>
            </div>
            <div className="forgot">
              <a href="#forgot">Forgot password</a>
            </div>
          </div>
          <button type="submit" className="login-btn" disabled={isLoading} aria-busy={isLoading}>
            {isLoading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
}

